module.exports = __webpack_public_path__ + "media/Valut Closing.ace1692f.mp3";